import { useState, useRef } from "react";
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';


export default function DynamicFaq({ faqs }) {
  const faqList = Array.isArray(faqs) ? faqs : [];
  const [activeKey, setActiveKey] = useState("0");

  const [activeIndex] = useState(null);
  const [highlightStyle, setHighlightStyle] = useState({
    top: 0,
    height: 0,
    opacity: 0,
  });

  const containerRef = useRef(null);
  const item1Ref = useRef(null);
  const item2Ref = useRef(null);
  const item3Ref = useRef(null);
  const item4Ref = useRef(null);
  const item5Ref = useRef(null);

  const allRefs = [item1Ref, item2Ref, item3Ref, item4Ref, item5Ref];

  const updateHighlight = (index, isActive = false) => {
    const el = allRefs[index].current;
    if (!el || !containerRef.current) return;
    const rect = el.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();

    setHighlightStyle({
      top: rect.top - containerRect.top,
      height: rect.height,
      opacity: isActive ? 0 : 1,
    });
  };

  const handleMouseEnter = (index) => {
    if (index !== activeIndex) updateHighlight(index, false);
  };

  const handleMouseLeave = () => {
    if (activeIndex !== null) {
      updateHighlight(activeIndex, true);
    } else {
      setHighlightStyle((prev) => ({ ...prev, opacity: 0 }));
    }
  };

  return (
    <>
      <section className="dynamicfaq-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="dynamicfaq-firsttext">
                <span>Frequently Asked Questions.</span>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="faq-dropdown">
                <span className="dynamicfaq-sapn">Our faq’S</span>
                <p className="ourfaq-para">Find clear answers to common questions about our luxury interior design process,
                  timelines, customization, materials, and services.</p>

                <div className="list-container" ref={containerRef} onMouseLeave={handleMouseLeave}>
                  <ul className="list-findserv">
                    <li ref={item1Ref} className={`list-item ${activeIndex === 0 ? "active" : ""}`} onMouseEnter={() => handleMouseEnter(0)}>
                      <Link to={"/contact"}><img src="/image/findlist-1.webp" alt="icon" /> Book a consultation</Link>
                    </li>

                    <li ref={item2Ref} className={`list-item ${activeIndex === 1 ? "active" : ""}`} onMouseEnter={() => handleMouseEnter(1)}>
                      <Link to={"/contact"}><img src="/image/findlist-2.webp" alt="icon" /> Request information</Link>
                    </li>

                    <li ref={item3Ref} className={`list-item ${activeIndex === 2 ? "active" : ""}`} onMouseEnter={() => handleMouseEnter(2)}>
                      <a href="/image/Saysha_catalogue.pdf" download rel="noopener noreferrer"><img src="/image/findlist-3.webp" alt="icon" /> Download the Saysha Deck catalogue</a>
                    </li>
                  </ul>

                  <div className="highlight" style={{
                    top: highlightStyle.top,
                    height: highlightStyle.height,
                    opacity: highlightStyle.opacity,
                  }} />
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <div div className="accor-area">
                <Accordion className="custom-accordion" activeKey={activeKey} onSelect={(key) => setActiveKey(key)}> {faqList.map((item, index) => { const key = index.toString();
                return (
                    <Accordion.Item eventKey={key} key={key}>
                      <Accordion.Header as="div">
                        {item.question}
                        <span>{activeKey === key ? "−" : "+"}</span>
                      </Accordion.Header>

                      <Accordion.Body>
                        {item.answer}
                      </Accordion.Body>
                    </Accordion.Item>
                   );
                  })}
                </Accordion>
              </div>
            </div>
          </div></div>
      </section>

    </>
  )
}